import AdprofitlistComponent from '@/view/adprofitlist'
const adProfitList = {
  name: 'ad-profit-list',
  component: AdprofitlistComponent,
  meta: {
    title: '收益明细'
  }
}
export default adProfitList
